import { Task } from '../types';
import { formatTaskDateRange } from './Utils';

export const formatTaskScheduleLabel = (
    dueDate?: Date,
    schedule?: Task['schedule'],
) => {
    if (!dueDate) return '';
    return formatTaskDateRange(dueDate.toISOString(), schedule);
};
